import React from 'react'
import Box from '@mui/material/Box'

import RefundScanModal from './components/scan/RefundScanModal'
import RefundApprovalConfirmDialogs from './components/approval/RefundApprovalConfirmDialogs'
import RefundNcrDialog from './components/ncr/RefundNcrDialog'
import useRefundApprovalDetail from './hooks/useRefundApprovalDetail'
import RefundApprovalDetailDesktop from './desktop/RefundApprovalDetailDesktop'
import RefundApprovalDetailMobile from './mobile/RefundApprovalDetailMobile'

const RefundApprovalDetail = ({
  activity,
  onRefresh,
  onActionSuccess,
  onActionError,
  isMobileLayout = false
}) => {
  const {
    activeTab,
    setActiveTab,
    detailTabs,
    canViewHistory,
    statusOption,
    headerData,
    summaryFields,
    fieldsToRender,
    paymentAttachments,
    progressPercent,
    progressSummaryMetrics,
    processingLines,
    processedLinesCount,
    allLinesRejected,
    canApproveCount,
    canWrite,
    canRegisterNcr,
    isFinalized,
    showLineActions,
    loading,
    isGeneratingPdf,
    copyTooltip,
    scanOpen,
    initialLineUid,
    confirmAction,
    lineToReject,
    setLineToReject,
    ncrDialogOpen,
    ncrNumber,
    ncrError,
    setNcrNumber,
    rejectReason,
    setRejectReason,
    confirmSummaryItems,
    openScanModal,
    closeScanModal,
    saveProcessingLines,
    handleApprove,
    handleReject,
    handleRegisterNcr,
    handleRejectLine,
    handleCopyTable,
    handleDownloadTableCsv,
    handleDownloadTablePdf,
    openRejectConfirm,
    openApproveConfirm,
    openNcrDialog,
    closeConfirmAction,
    closeRejectConfirm,
    closeNcrDialog
  } = useRefundApprovalDetail({ activity, onRefresh, onActionSuccess, onActionError })

  const detailViewProps = {
    activity,
    activeTab,
    setActiveTab,
    detailTabs,
    canViewHistory,
    statusOption,
    headerData,
    summaryFields,
    fieldsToRender,
    paymentAttachments,
    progressPercent,
    progressSummaryMetrics,
    processingLines,
    processedLinesCount,
    allLinesRejected,
    canApproveCount,
    canWrite,
    canRegisterNcr,
    isFinalized,
    showLineActions,
    loading,
    isGeneratingPdf,
    copyTooltip,
    openScanModal,
    setLineToReject,
    handleCopyTable,
    handleDownloadTableCsv,
    handleDownloadTablePdf,
    openRejectConfirm,
    openApproveConfirm,
    openNcrDialog
  }

  return (
    <Box sx={{ p: { xs: 1.5, md: 2 } }}>
      {isMobileLayout ? (
        <RefundApprovalDetailMobile {...detailViewProps} />
      ) : (
        <RefundApprovalDetailDesktop {...detailViewProps} />
      )}

      <RefundScanModal
        open={scanOpen}
        onClose={closeScanModal}
        lines={processingLines}
        onSave={saveProcessingLines}
        initialLineUid={initialLineUid}
      />

      <RefundApprovalConfirmDialogs
        lineToReject={lineToReject}
        confirmAction={confirmAction}
        loading={loading}
        rejectReason={rejectReason}
        summaryItems={confirmSummaryItems}
        onCloseLineReject={() => setLineToReject(null)}
        onConfirmLineReject={handleRejectLine}
        onCloseApprove={closeConfirmAction}
        onConfirmApprove={handleApprove}
        onCloseReject={closeRejectConfirm}
        onConfirmReject={handleReject}
        onRejectReasonChange={setRejectReason}
      />

      <RefundNcrDialog
        open={ncrDialogOpen}
        ncrNumber={ncrNumber}
        error={ncrError}
        loading={loading}
        onChange={setNcrNumber}
        onClose={closeNcrDialog}
        onSave={handleRegisterNcr}
      />
    </Box>
  )
}

export default RefundApprovalDetail
